// src/components/LogoutModal.jsx
import React from "react";
import { Button } from "../ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "../ui/dialog";
import { AlertTriangle } from "lucide-react";
import { motion } from "framer-motion";

const LogoutModal = ({ 
  isOpen, 
  onClose, 
  title = "Session Expired", 
  description = "Your session has expired. Please login again to continue." 
}) => {
  
  const handleConfirm = () => {
    // clear storage just in case
    localStorage.removeItem("adminToken");
    localStorage.removeItem("userId");
    // redirect to login
    window.location.href = "/admin/login";
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <motion.div
          initial={{ scale: 0.95, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.2 }}
        >
          <DialogHeader>
            <div className="flex items-center gap-3">
              <div className="flex h-12 w-12 items-center justify-center rounded-full bg-yellow-100 dark:bg-yellow-900/20">
                <AlertTriangle className="h-6 w-6 text-yellow-600 dark:text-yellow-400" />
              </div>
              <div>
                <DialogTitle className="text-lg font-semibold">{title}</DialogTitle>
                <DialogDescription className="text-sm text-muted-foreground mt-1">
                  {description}
                </DialogDescription>
              </div>
            </div>
          </DialogHeader>

          <DialogFooter className="flex-col-reverse sm:flex-row gap-2">
            <Button 
              variant="destructive" 
              onClick={handleConfirm}
              className="w-full sm:w-auto mt-5"
            >
              Login Again
            </Button>
          </DialogFooter>
        </motion.div>
      </DialogContent>
    </Dialog>
  );
};

export default LogoutModal;
